import { AuthenticationRepository } from "@src/cloud-connect/node-manager/authentication/authentication-repository";

export class AxiosAuthenticationHeadersBuilder {
  private authenticationRepository: AuthenticationRepository;

  constructor(authenticationRepository?: AuthenticationRepository) {
    this.authenticationRepository =
      authenticationRepository || new AuthenticationRepository();
  }

  public build(): Record<string, string> {
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.authenticationRepository.getAccessToken()}`,
    };
  }
  public buildForMultipart(): Record<string, string> {
    return {
      // "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${this.authenticationRepository.getAccessToken()}`,
    };
  }
}
